import React from "react";

import {
  ActionMode,
  ExperienceListDto,
  HistoryDto,
  OrganizationDto,
} from "@intelligems/ig-types";
import { HaltExperienceButton } from "@src/features/experiments/components/experienceTestActions/HaltExperienceButton";
import { StartExperienceButton } from "@src/features/experiments/components/experienceTestActions/StartExperienceButton";
import { Experience } from "@src/store/slices/experiences/types";

interface ExperimentActionButtonProps {
  experiencesList: ExperienceListDto[];
  organization: OrganizationDto;
  renderLocation: "overview" | "experience";
  onlyStart: boolean;
  currentExperiment?: Experience;
  rowExperiment: Experience;
  onExperimentEnd: (experiment: Experience) => void;
  onExperimentPause: (experiment: Experience) => void;
  onExperimentStartWrapper: (
    rowExperience: Experience,
    history: HistoryDto[],
    isSubscriptionStartActive?: boolean
  ) => void;
  hasSchedule: boolean;
  actionMode: ActionMode;
}
export const ExperimentActionButtons = ({
  experiencesList,
  organization,
  renderLocation,
  onlyStart,
  currentExperiment,
  rowExperiment,
  onExperimentEnd,
  onExperimentPause,
  onExperimentStartWrapper,
  hasSchedule,
  actionMode,
}: ExperimentActionButtonProps) => {
  if (actionMode === "create" && renderLocation === "experience") {
    return null;
  }
  if (onlyStart) {
    return (
      <StartExperienceButton
        rowExperience={rowExperiment}
        currentExperience={currentExperiment}
        experiencesList={experiencesList}
        organization={organization}
        onStartButtonClick={onExperimentStartWrapper}
        renderLocation={renderLocation}
        hasSchedule={hasSchedule}
      />
    );
  }

  if (rowExperiment.status === "ended") {
    return null;
  }

  return (
    <>
      <HaltExperienceButton
        currentExperience={currentExperiment}
        onActionExpButtonClick={onExperimentEnd}
        rowExperience={rowExperiment}
        action={"end"}
        renderLocation={renderLocation}
        hasSchedule={hasSchedule}
        onPauseExp={onExperimentPause}
      />
      {rowExperiment.status === "paused" ? (
        <StartExperienceButton
          rowExperience={rowExperiment}
          currentExperience={currentExperiment}
          experiencesList={experiencesList}
          organization={organization}
          onStartButtonClick={onExperimentStartWrapper}
          renderLocation={renderLocation}
          hasSchedule={hasSchedule}
        />
      ) : renderLocation === "overview" ? (
        <HaltExperienceButton
          currentExperience={currentExperiment}
          onActionExpButtonClick={onExperimentPause}
          rowExperience={rowExperiment}
          action={"pause"}
          renderLocation={renderLocation}
          hasSchedule={hasSchedule}
        />
      ) : null}
    </>
  );
};
